(function() {
	'use strict';
	angular.module('nasracApp').factory('NonNctc', NonNctc);

	NonNctc.$inject = [ '$resource' ];

	function NonNctc($resource) {
		var resourceUrl = 'api/nonnctc';
		var xlsxContentType = 'application/octet-stream';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'getReportDates' : {
				method : 'GET',
				url : 'api/nonnctc/reportdates',
				isArray : true
			},
			'getMsoNames' : {
				method : 'GET',
				url : 'api/nonnctc/msonames',
				isArray : true
			},
			'download' : {
				method : 'GET',
				url : 'api/nonnctc/download',
				headers : {
					accept : xlsxContentType
				},
				responseType : 'arraybuffer',
				cache : false,
				transformResponse : function(data) {
					return {
						response : new Blob([ data ], {
							type : xlsxContentType
						})
					};
				}
			},

		});
	}
})();
